// Who a client-facing transaction email is addressed to. Every client on the
// deal with an email lands on the To line together — not just the first one
// (Henry, 2026-09-01: "this needs to pull in EVERYONE on the deall"). One
// email, all clients visible to each other, matching how you'd write to a
// couple by hand. Comma-joined because the To field (and the Gmail API's To
// header) accepts a comma-separated address list.
export function allClientRecipients(contacts) {
  const withEmail = (contacts || []).filter(
    (c) => c && String(c.email || "").trim(),
  );
  return {
    email: withEmail.map((c) => String(c.email).trim()).join(", "),
    name: withEmail
      .map((c) => c.name || c.firstName || "")
      .filter(Boolean)
      .join(", "),
  };
}
